import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { css } from "styled-components";

/*

**** EC-231 Product Details Page (PDP) ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
partNumberStyles.labelText = {
    css: css`
        font-weight: normal;
        // EC-617 : Fixing css issues on PLP & PDP
        font-size: 16px;
        margin-right: 15px;
    `,
};

partNumberStyles.valueText = {
    css: css`
        font-weight: 500;
        // EC-617 : Fixing css issues on PLP & PDP
        font-size: 16px;
        margin-bottom: 5px;
    `,
};
/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS. */
